import {Box, Button, FormControl, InputLabel, MenuItem, Select, Stack} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import React from "react";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import { AgendaV3 } from "crqlar-react-common/dist/models/agenda/agenda.model";
import {SelectChangeEvent} from "@mui/material/Select";

interface Props {
    organizationName?: string;
    selectedAgendaId: string;
    rangeFromLocalStorage?: Date | undefined
    agendasData: AgendaV3[] | undefined
    handleChangeAgenda: (
        e: SelectChangeEvent<string>,
    ) => Promise<void>;
}

const AgendaDropDown = (props: Props) => {
    const {t} = useLocalize()

    return(
        <Stack direction={"row"} gap={1}>
            <Box>
                <Button
                    variant="outlined"
                    endIcon={<OpenInNewIcon/>}
                    component="a"
                    href={`${process.env.REACT_APP_AGENDA_PUBLIC_URL}/${encodeURIComponent(props.organizationName ?? "")}/${props.selectedAgendaId}?date=${props.rangeFromLocalStorage?.toISOString()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t("View Preview")}
                </Button>
            </Box>

            <FormControl
                sx={{
                    marginLeft: 'auto',
                    width: 160,
                }}
            >
                <InputLabel
                    id="agenda-filter-select-lbl">{t('Agenda')}</InputLabel>
                <Select
                    labelId="agenda-filter-select-lbl"
                    id="agenda-filter-select"
                    label={t('Agenda')}
                    value={props.selectedAgendaId || props.agendasData?.[0]?.id || ''}
                    onChange={props.handleChangeAgenda}
                    size={'small'}
                >
                    {props.agendasData?.map((agenda) => (
                        <MenuItem
                            key={agenda.id}
                            value={agenda.id}
                        >
                            {agenda.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>



        </Stack>
    )
}

export default AgendaDropDown
